import {Component, Output, OnChanges, ElementRef, EventEmitter, Input, ViewChild} from '@angular/core';

import { Rule, CDSNode, Package, RuleSet } from '../services/capd.model';
import { PackageService } from '../services/package.service';

declare var $: any;

@Component({
  selector: 'pak-update',
  templateUrl: './update.component.html',
  // inputs: ['oldPak', 'org']
})

export class UpdateComponent implements OnChanges {

  @Output() packUpdate: EventEmitter<any> = new EventEmitter();
  @Input() oldPak: Package;
  @Input() org: CDSNode;

  newVer: string;
  newRuleset: RuleSet;

  selectedRule: Rule;
  oldSelectedRule: Rule = null;
  op: string;

  constructor(private _service: PackageService,
              private elementRef: ElementRef) { }

  ngOnChanges() {
    this.newVer = this.oldPak.upgradeVersion;
    this._service.reviewPackageUpdate(this.oldPak).then((rules: RuleSet) => this.newRuleset = rules);
  }

  selectRule(rule, newOp: string) {
    this.op = newOp;
    if (newOp === 'c') {
      this.selectedRule = rule.to;
      this.oldSelectedRule = rule.from;
    }
    else {
      this.selectedRule = rule;
      this.oldSelectedRule = this.selectedRule;
    }
  }

  onConfirm() {
    const newVer = this.oldPak.id.replace(/-([^-]*)$/, '-' + this.oldPak.upgradeVersion);
    this._service.updatePackage(this.oldPak, this.org).then(res => {
      this.packUpdate.emit({version: newVer, newRules: this.newRuleset.addedRules});
      $(this.elementRef.nativeElement).find('#modal-package-review').hide();
    })
    .catch(err => {
      this.packUpdate.emit({version: newVer, newRules: this.newRuleset.addedRules});
      $(this.elementRef.nativeElement).find('#modal-package-review').hide();
    });
  }
}
